



























































































































































import Vue from 'vue'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { delay } from 'lodash'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as weixin from '@ivy/fts/weixin'
import * as utils from '@ivy/fts/utils'

class Report {
  baby_name: string
  report_tips?: string
  total_completed_lessons: number
  completed_lessons: number
  not_completed_words: DayWords[]
  completed_words: DayWords[]
  error_lessons_words: ErrorWord[]
  words_example: WordExample[]
  not_completed: NotCompletedLesson
  course_title: string
}

interface NotCompletedLesson {
  not_completed_lesson: NotCompletedLessonItem[]
  not_completed_unit_day: string[]
}

interface NotCompletedLessonItem {
  unit_title: string
  lesson_title: string[]
}

interface DayLog {
  not_completed_lesson: string[]
  not_completed_unit_day: string[]
}

interface DayWords {
  unit_title: string
  words: Word[]
}

interface Word {
  english: string
  chinese: string
}

interface ErrorWord {
  word: string
  unit_lesson: UnitLessonItem[]
}

interface WordExample {
  words: string[]
  example: string
}

interface UnitLessonItem {
  unit_title: string
  lesson_title: string
}

interface ReadingItem {
  english: string
  chinese: string
}

export default Vue.extend({
  name: 'LearningReport',
  data() {
    return {
      report: new Report(),
      nickname: '',
      phone: '',
      courseId: '',
      isFetchingData: false,
      unitIds: [''],
      currentPage: 1,
      totalPages: 2,
    }
  },

  async created() {
    await env.init()
    this.phone = this.$route.query.phone || ''
    this.courseId = this.$route.query.courseId || ''
    this.unitIds = this.$route.query.unitIds.split(',')
    this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.isFetchingData) {
        return
      }
      this.isFetchingData = true
      const isLogin = await env.getIsLogin()
      if (!this.courseId || !this.courseId.length) {
        this.$message ? this.$message.error('课程id无效') : alert('课程id无效')
      } else if (!this.unitIds || !this.unitIds.length) {
        this.$message
          ? this.$message.error('课时ids无效')
          : alert('课时ids无效')
      } else if (!isLogin) {
        return await env.login()
      }
      const url = `/api/crm/tools/user/getLearningReport`
      const { data } = await this.$axios.get(url, {
        params: {
          course_id: this.courseId,
          unit_ids: this.unitIds,
        },
      })
      this.isFetchingData = false
      this.report = data
      setTimeout(() => {
        // 1秒后执行的代码
        console.log('1秒后执行')
        // this.exportToPdf(); // 调用其他方法
      }, 1000) // 1000毫秒 = 1秒
    },

    exportToPdf() {
      // 显示加载提示
      this.$message
        ? this.$message('PDF生成中，请稍候...')
        : alert('PDF生成中，请稍候...')

      // 获取要导出的DOM元素
      const element = this.$refs.contentToExport

      // 使用html2canvas将DOM元素转换为canvas
      html2canvas(element, {
        useCORS: true, // 允许加载跨域图片
        scale: 2, // 提高清晰度
        logging: false, // 关闭日志
        backgroundColor: '#ffffff', // 设置背景色为白色
      })
        .then(canvas => {
          // 创建jsPDF实例，A4大小
          const pdf = new jsPDF('p', 'mm', 'a4')

          // 获取canvas宽高和A4纸张宽高比例
          const contentWidth = canvas.width
          const contentHeight = canvas.height
          const pageWidth = pdf.internal.pageSize.getWidth()
          const pageHeight = pdf.internal.pageSize.getHeight()
          const ratio = contentWidth / pageWidth

          // 按比例计算内容高度
          const pdfHeight = contentHeight / ratio

          // 如果内容高度大于页面高度，需要分页处理
          let position = 0
          let leftHeight = pdfHeight

          // 添加第一页
          const imgData = canvas.toDataURL('image/jpeg', 1.0)
          pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, pdfHeight)
          leftHeight -= pageHeight

          // 如果有剩余内容，继续分页添加
          while (leftHeight > 0) {
            position -= pageHeight
            pdf.addPage()
            pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, pdfHeight)
            leftHeight -= pageHeight
          }

          // 生成文件名（使用当前日期时间）
          const fileName =
            '学习周报_' +
            this.nickname +
            '_' +
            this.report.course_title +
            '_' +
            // new Date().toLocaleDateString().replace(/\//g, '-') +
            '.pdf'
          // 保存并下载PDF
          pdf.save(fileName)
          // 显示成功提示
          this.$message
            ? this.$message.success('PDF已成功生成并下载')
            : alert('PDF已成功生成并下载')
        })
        .catch(error => {
          console.error('PDF生成失败:', error)
          this.$message
            ? this.$message.error('PDF生成失败')
            : alert('PDF生成失败')
        })
    },

    highlightText(text, keywords) {
      if (!keywords || keywords.length === 0) return text
      keywords = [...new Set(keywords)]
      let result = text
      keywords.forEach(keyword => {
        if (keyword.length > 0) {
          const sortedKeywords = [...keywords].sort(
            (a, b) => b.length - a.length
          )
          const regex = new RegExp(`(${sortedKeywords.join('|')})`, 'g')
          result = result.replace(
            regex,
            match => `<span style="color: #e74c3c;">${match}</span>`
          )
        }
      })
      return result
    },
    getErrorDaysText(word: ErrorWord) {
      var copy = word.word + ' 一词在'
      var highlights: string[] = []
      highlights = highlights.concat(word.word)
      word.unit_lesson.forEach(lesson => {
        copy += '“' + lesson.unit_title + ' ' + lesson.lesson_title + '”' + '、'
        highlights = highlights.concat(lesson.unit_title)
        if (lesson.lesson_title.length > 0) {
          highlights = highlights.concat(lesson.lesson_title)
        }
      })
      copy = copy.slice(0, -1)
      copy += '环节中出现错误'
      return this.highlightText(copy, highlights)
    },
    getCompletedDaysText() {
      if (
        !this.report.completed_words ||
        this.report.completed_words.length === 0
      )
        return ''
      return this.report.completed_words.map(item => item.unit_title).join('/')
    },
    getUncompletedDaysText() {
      if (!this.report.not_completed) {
        return
      }
      if (
        this.report.not_completed.not_completed_lesson.length +
          this.report.not_completed.not_completed_unit_day.length ===
        0
      ) {
        return '无'
      }
      let result = ''
      let highlights: string[] = []
      if (this.report.not_completed.not_completed_lesson) {
        this.report.not_completed.not_completed_lesson.forEach(lesson => {
          result += lesson.unit_title
          highlights = highlights.concat(lesson.unit_title)
          result += ' 的'
          lesson.lesson_title.forEach(title => {
            result += '“' + title + '”'
            highlights = highlights.concat(title)
            result += '、'
          })
          result = result.slice(0, -1)
          result += '环节及'
        })
        result = result.slice(0, -1)
      }
      if (
        result.length > 0 &&
        this.report.not_completed.not_completed_unit_day
      ) {
        result += '及'
      }
      this.report.not_completed.not_completed_unit_day.forEach(day => {
        highlights = highlights.concat(day)
        result += day
        result += '、'
      })
      result = result.slice(0, -1)
      result += '没有完成'
      return this.highlightText(result, highlights)
    },
  },
})
